import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import Header from '../components/Header/Header'
import { useSearchTitleTypeMutation } from '../../../services'
import { UspConfigurationCarTitleTypeViewResult } from '../../../models'
import InventoryTitleTypesTable from './components/InventoryTitleTypesTable'
import AddEditTitleTypesModal from './components/AddEditTitleTypesModal'
import { Button, Card, Container, Grid } from '@mui/material'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'
import Iconify from '../../../components/iconify'

const SettingsInventoryTitleTypes = () => {
  const [rowData, setRowData] = useState({})
  const [openAddEditModal, setOpenAddEditModal] = useState(false)
  const [type, setType] = useState('')
  const [searchTitleType, { data, isLoading }] = useSearchTitleTypeMutation()
  const [carTitleTypeData, setCarTitleTypeData] = useState<UspConfigurationCarTitleTypeViewResult[]>([])

  const handleSubmit = (values?: any) => {
    searchTitleType({
      uspConfigurationCarTitleTypeView: {
        searchString: values?.searhString,
        isIncludeInactive: values?.isIncludeInactive,
      },
    })
  }

  const handleOpenModal = () => {
    setOpenAddEditModal(true)
    setType('add')
  }

  const handleCloseModal = () => {
    setOpenAddEditModal(false)
  }

  useEffect(() => {
    if (data) {
      setCarTitleTypeData(data)
    }
  }, [data])

  return (
    <Container>
      <CustomBreadcrumbs
        heading='Title Types'
        links={[
          {
            name: 'List',
          },
        ]}
        action={
          <>
            <Button onClick={handleOpenModal} variant='contained' startIcon={<Iconify icon='mingcute:add-line' />}>
              Add new
            </Button>
          </>
        }
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Form onSubmit={handleSubmit} initialValues={{ searhString: null, isIncludeInactive: false }}>
        {({ handleSubmit, form: { submit } }: any) => (
          <>
            <form onSubmit={handleSubmit}>
              <Card>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Header submit={submit} title='' handleOpenModal={handleOpenModal} />
                  </Grid>
                  <Grid item xs={12}>
                    <InventoryTitleTypesTable
                      setOpenAddEditModal={setOpenAddEditModal}
                      setType={setType}
                      setRowData={setRowData}
                      handleOpenModal={handleOpenModal}
                      loading={isLoading}
                      data={carTitleTypeData}
                      setData={setCarTitleTypeData}
                    />
                  </Grid>
                </Grid>
              </Card>
            </form>
            <AddEditTitleTypesModal
              submit={submit}
              open={openAddEditModal}
              onClose={handleCloseModal}
              type={type}
              rowData={rowData as UspConfigurationCarTitleTypeViewResult}
            />
          </>
        )}
      </Form>
    </Container>
  )
}

export default SettingsInventoryTitleTypes
